<nz-form-item class="label-on-top">
  <nz-form-label *ngIf="label" [nzRequired]="isRequired(control)">
    {{ label }}
  </nz-form-label>
  <nz-form-control [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    <nz-cascader
      [nzOptions]="nzOptions"
      [formControl]="control"
      (ngModelChange)="onChanges($event)"
      [nzPlaceHolder]="placeholder"
      [nzDisabled]="isDisabled"
      [nzSize]="size"
    >
    </nz-cascader>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>
